/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const EvidenceStatus = {
    Missing: 'MISSING',
    NotProvided: 'NOT_PROVIDED',
    Provided: 'PROVIDED',
    PendingAnalysis: 'PENDING_ANALYSIS',
    Analyzed: 'ANALYZED',
    Rejected: 'REJECTED',
    AnalysisFailed: 'ANALYSIS_FAILED',
    ConfirmReuse: 'CONFIRM_REUSE'
} as const;
export type EvidenceStatus = typeof EvidenceStatus[keyof typeof EvidenceStatus];

